module.exports = __webpack_public_path__ + "img/avatar5.2ad1b235.png";